export default "__VITE_ASSET__BKxPZQGF__"